/**
 * Created by Ning Jiang on 6/20/2018.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {FruitsGameMode} from "../gamemode/FruitsGameMode";
import {IFruitsParsedServerData} from "../server/data/FruitsParsedServerData";
import {FruitsParsedGameData} from "../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../server/data/FruitsParsedInitData";
import {FruitsReelSymbol} from "../reelsymbol/FruitsReelSymbol";
import {FruitsGameConfig} from "../FruitsGameConfig";
import { FruitsGameModuleConfig } from "../FruitsGameModuleConfig";


export class BigStickySymbolController extends BaseController {
    private _isNextSticky:boolean;
    private _stickSymbol:string;
    private _mode:string;
    private _stickyPositions:boolean[];
    private _bonusGameQueued:boolean;
    private _scatterPositions:string[][];
    private _hasWin:boolean = false;

    public static readonly STICK_SYMBOLS:string = "bigStickySymbolController_stickSymbols";
    public static readonly RESET_SYMBOL_STATES:string = "bigStickySymbolController_resetSymbolStates";

    constructor() {
        super();
        this.addEventListener();
    }

    private addEventListener():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onGameRestore());
        EventHandler.addEventListener(this, BigStickySymbolController.RESET_SYMBOL_STATES, (event:GameEvent) => this.resetSymbolStates());
        EventHandler.addEventListener(this, BigStickySymbolController.STICK_SYMBOLS, (event:GameEvent) => FruitsGameModuleConfig.stickyRespinOverlayView.stickInitialSymbols(this._stickyPositions, this._stickSymbol));
    }

    protected onGameDataParsed(data:IFruitsParsedServerData):void {
        this._bonusGameQueued = data.bonusGameQueued;
        this._scatterPositions = (<FruitsParsedInitData>data).bonusInitReels;
        this._isNextSticky = data.nextMode === FruitsGameMode.STICKY_RESPIN;
        this._mode = data.mode;
        this._stickyPositions = (<FruitsParsedGameData>data).overlayStickySymbolsAfterSpin;
        if(this._isNextSticky) {
            this._stickSymbol = data.stickySymbol;
        }
        this._hasWin = data.totalWin > 0;
    }

    private onGameRestore():void {
        if(this._isNextSticky) {
            FruitsGameModuleConfig.stickyRespinView.getStickyAnimation2x2(this._stickSymbol, true);
            FruitsGameModuleConfig.stickyRespinView.showRainbow();

            if(this._scatterPositions && this._bonusGameQueued) {
                let rInd:number = 0, sInd:number = 0;
                this._scatterPositions.forEach((reel) => {
                    sInd = 0;
                    reel.forEach((symbol) => {
                        if(symbol === "S")
                            FruitsGameModuleConfig.bonusOverlayView.activateScatterFrame(rInd * 3 + 4 + sInd);
                        sInd++;
                    });
                    rInd++;
                });
            }
        }
    }

    private resetSymbolStates():void {
        if(!this._hasWin) {
            for(let i:number = 0; i < 4; i++) {
                let sym:FruitsReelSymbol = <FruitsReelSymbol>Reels.getSymbol(i, 0);
                sym.changeState({
                    state : FruitsGameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration : 0.15,
                    setStack : false
                })
            }
        }
    }

}